<div class="flex-auto bg-card">

    <!-- Header -->
    <div class="flex items-center justify-between py-3 px-8 border-b">
        <div>
            <div class="text-2xl font-bold">Historial de informes</div>
            <div class="text-sm text-secondary">Versiones generadas del manual</div>
        </div>
    </div>

    <!-- Listado -->
    <div class="my-6 rounded-2xl border border-gray-200 bg-card p-6 shadow-sm">
        <ng-container *ngIf="BitacoraInforme?.length; else sinInformes">
            <div class="overflow-y-auto">
                <table class="w-full">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-3 py-3 text-left font-semibold text-gray-700">Versión</th>
                            <th class="px-3 py-3 text-left font-semibold text-gray-700">Creado por</th>
                            <th class="px-3 py-3 text-left font-semibold text-gray-700">Fecha</th>
                            <th class="px-3 py-3 text-right font-semibold text-gray-700">Acciones</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100">
                        <tr *ngFor="let informe of BitacoraInforme" class="hover:bg-gray-50">
                            <td class="px-3 py-1">
                                <div class="inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
                                    v{{ informe.versionInforme }}
                                </div>
                            </td>
                            <td class="px-3 py-1">
                                <div class="text-sm font-semibold text-gray-800">{{ informe.creadoPor?.nombreCompleto }}</div>
                                <div class="text-xs text-secondary">{{ informe.creadoPor?.email }}</div>
                            </td>
                            <td class="px-3 py-1 text-sm text-secondary">
                                {{ informe.fechaCreacion | date:'medium' }}
                            </td>
                            <td class="px-3 py-1 text-right">
                                <button type="button"
                                    (click)="descargarInforme(informe)"
                                    [disabled]="descargandoInforme"
                                    class="inline-flex items-center cursor-pointer">
                                    <mat-icon>arrow_circle_down</mat-icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>

        <ng-template #sinInformes>
            <div class="flex flex-col items-center justify-center gap-2 py-10 text-secondary">
                <div class="text-base font-semibold text-gray-700">No hay informes generados</div>
                <div class="text-sm text-secondary">Cuando se generen informes, aparecer&aacute;n listados aqu&iacute;.</div>
            </div>
        </ng-template>
    </div>
</div>
